(function(){
  if(window.__txPremium){return;}window.__txPremium=1;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html=document.documentElement;
  var hasIO='IntersectionObserver' in window;
  if(!reduce&&hasIO){html.classList.add('tx-motion');}else{html.classList.remove('tx-motion');}
  html.classList.add('tx-ready');

  function words(){
    var hs=document.querySelectorAll('.tx-show__title,.tx-home .tx-h2,.tx-safe__title');
    for(var i=0;i<hs.length;i++){
      var h=hs[i];if(h.classList.contains('tx-words')||h.children.length){continue;}
      var t=h.textContent.trim().split(/\s+/),out='';
      for(var k=0;k<t.length;k++){out+='<span class="tx-w" style="--i:'+k+'">'+t[k].replace(/[&<>]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;'}[c];})+'</span>'+(k<t.length-1?' ':'');}
      h.setAttribute('aria-label',h.textContent.trim());h.innerHTML=out;h.classList.add('tx-words','tx-reveal');
    }
  }

  function reveal(){
    var els=document.querySelectorAll('.tx-reveal:not(.is-in)');
    if(reduce||!hasIO){for(var i=0;i<els.length;i++){els[i].classList.add('is-in');}return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    for(var j=0;j<els.length;j++){io.observe(els[j]);}
  }

  /* tarjetas y bloques que entran escalonados */
  var POP='.tlf2-card,.tlf2-section-head,.tlf2-assurance,.tlf2-process,.tl-game-media,.tl-game-panel,.tx-prod,.tx-facts__list li';
  var popIO=null,gate=false;
  function popAll(){
    if(gate){return;}
    var els=document.querySelectorAll(POP);
    if(!html.classList.contains('tx-motion')){return;}
    if(!popIO){
      popIO=new IntersectionObserver(function(entries){
        var k=0;
        entries.forEach(function(e){
          if(!e.isIntersecting){return;}
          var el=e.target,d=Math.min(k++,7)*70;
          popIO.unobserve(el);
          el.style.setProperty('--td',d+'ms');
          el.classList.add('tx-in');
          setTimeout(function(){el.classList.add('tx-done');el.classList.remove('tx-in');el.style.removeProperty('--td');},d+1000);
        });
      },{rootMargin:'0px 0px -6% 0px',threshold:.06});
    }
    for(var i=0;i<els.length;i++){if(!els[i].__txPop){els[i].__txPop=1;popIO.observe(els[i]);}}
    var f=document.querySelector('.tx-facts__list');
    if(f&&!f.__txSweep){f.__txSweep=1;var fo=new IntersectionObserver(function(en){if(en[0].isIntersecting){f.classList.add('tx-sweep');fo.disconnect();}},{threshold:.4});fo.observe(f);}
  }

  /* efectos ligados al scroll */
  var bar,show,how,howLis,safe,safeWords,coins,coinImg,ticking=false;
  function clamp(v){return v<0?0:v>1?1:v;}
  function measure(){
    ticking=false;
    var vh=window.innerHeight||1,de=document.documentElement;
    if(bar){var max=de.scrollHeight-vh;bar.style.setProperty('--sp',max>0?clamp(window.scrollY/max).toFixed(4):0);}
    if(show){var r=show.getBoundingClientRect();if(r.bottom>-50){show.style.setProperty('--hp',clamp(-r.top/(r.height*.9)).toFixed(3));}}
    if(how){
      var hr=how.getBoundingClientRect();
      if(hr.top<vh&&hr.bottom>0){
        var p=clamp((vh*.62-hr.top)/hr.height);how.style.setProperty('--p',p.toFixed(3));
        for(var i=0;i<howLis.length;i++){var li=howLis[i];var at=(li.offsetTop+34)/how.offsetHeight;li.classList.toggle('is-lit',p>=at-.04);}
      }
    }
    if(safe&&safeWords.length){
      var sr=safe.getBoundingClientRect();
      if(sr.top<vh&&sr.bottom>0){
        var sp=clamp((vh*.88-sr.top)/(vh*.42)),n=safeWords.length;
        for(var w=0;w<n;w++){safeWords[w].classList.toggle('is-lit',sp>=(w+1)/n*.96);}
      }
    }
    if(coins&&coinImg){var cr=coins.getBoundingClientRect();if(cr.top<vh&&cr.bottom>0){coinImg.style.setProperty('--p',clamp((vh-cr.top)/(vh+cr.height)).toFixed(3));}}
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(measure);}}
  function scrollFx(){
    if(reduce){return;}
    if(document.body&&document.body.scrollHeight>window.innerHeight*1.6&&!document.querySelector('.tx-progress')){
      bar=document.createElement('div');bar.className='tx-progress';bar.setAttribute('aria-hidden','true');document.body.appendChild(bar);
    }
    show=document.getElementById('tx-show');
    how=document.querySelector('.tx-how__list');howLis=how?how.querySelectorAll('li'):[];
    safe=document.querySelector('.tx-safe__title');safeWords=safe?safe.querySelectorAll('.tx-w'):[];
    coins=document.querySelector('.tx-coins__card');coinImg=coins&&coins.querySelector('.tx-coins__img');
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    measure();
  }

  /* preguntas que se abren suave */
  function faq(){
    if(reduce){return;}
    document.addEventListener('click',function(e){
      var s=e.target.closest&&e.target.closest('.tx-faq__list summary');if(!s){return;}
      var d=s.parentNode,p=d.querySelector('p');if(!p||!p.animate||d.__busy){return;}
      e.preventDefault();d.__busy=1;
      var ease='cubic-bezier(.23,1,.32,1)';
      if(d.open){
        var h=p.offsetHeight;
        var a=p.animate([{height:h+'px',opacity:1,marginBottom:'18px'},{height:'0px',opacity:0,marginBottom:'0px'}],{duration:240,easing:ease});
        a.onfinish=function(){d.open=false;d.__busy=0;};
      }else{
        d.open=true;var h2=p.offsetHeight;
        var b=p.animate([{height:'0px',opacity:0,marginBottom:'0px',transform:'translateY(-6px)'},{height:h2+'px',opacity:1,marginBottom:'18px',transform:'none'}],{duration:340,easing:ease});
        b.onfinish=function(){d.__busy=0;};
      }
    });
  }

  /* inclinación 3D con el mouse (solo computadora) */
  function tilt(){
    if(reduce||!window.matchMedia('(hover:hover) and (pointer:fine)').matches){return;}
    var cur=null;
    document.addEventListener('pointermove',function(e){
      var c=e.target.closest&&e.target.closest('.tx-prod,.tlf2-card');
      if(cur&&cur!==c){cur.classList.remove('tx-tilting');cur.style.removeProperty('--rx');cur.style.removeProperty('--ry');}
      cur=c;if(!c||!c.classList.contains('tx-done')&&html.classList.contains('tx-motion')){return;}
      var r=c.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
      c.style.setProperty('--ry',((x-.5)*10).toFixed(2)+'deg');c.style.setProperty('--rx',((.5-y)*10).toFixed(2)+'deg');
      c.style.setProperty('--mx',(x*100).toFixed(1)+'%');c.style.setProperty('--my',(y*100).toFixed(1)+'%');
      c.classList.add('tx-tilting');
    },{passive:true});
  }

  function themeColor(){
    var m=document.querySelector('meta[name="theme-color"]');
    if(!m){m=document.createElement('meta');m.name='theme-color';document.head.appendChild(m);}
    m.setAttribute('content','#0b0812');
  }
  function start(){
    if(!reduce){words();}
    themeColor();scrollFx();faq();tilt();
    /* si está la animación de entrada, las apariciones esperan a que se vaya la cortina */
    if(html.classList.contains('tl-intro')&&!html.classList.contains('tl-intro-out')){
      var went=false;function go(){if(went){return;}went=true;gate=false;reveal();popAll();}
      gate=true;document.addEventListener('tx:intro-done',go);setTimeout(go,5000);
    }else{reveal();popAll();}
    /* las páginas que pintan tarjetas después también entran animadas */
    if('MutationObserver' in window&&html.classList.contains('tx-motion')){
      var q=false;new MutationObserver(function(){if(!q){q=true;requestAnimationFrame(function(){q=false;popAll();});}}).observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
